import React from "react";
import { CollectedInvoicesAndNoticesProps } from "../../resources";
import { FormattedMessage } from "react-intl";
import { MyPageDataTable } from ".";
import {
	InvoiceStatusEnum,
	InvoiceStatusToString,
	formatDate,
} from "../../utils";

import { useSnackbar } from "notistack";
import { useCommonWidths } from "../../hooks";
import {
	downloadDocument,
	DownloadDocumentButton,
} from "./DownloadDocumentButton";

interface InvoiceTableProps {
	backofficeApplicationId: number;
	collectedInvoicesAndNotices: any[];
	limit?: number;
}

export const InvoiceTable = (props: InvoiceTableProps) => {
	const { collectedInvoicesAndNotices, backofficeApplicationId, ...rest } =
		props;
	const isMobile = useCommonWidths().isXsDown;
	const { enqueueSnackbar } = useSnackbar();

	return (
		<MyPageDataTable
			data={collectedInvoicesAndNotices.map(
				(data: CollectedInvoicesAndNoticesProps) => {
					return {
						...data,
						status: data.invoiceNumber
							? InvoiceStatusToString(data.status)
							: " - ",
						invoiceNumber: data.invoiceNumber
							? data.invoiceNumber
							: data.documentJobId,
						type: data.invoiceNumber ? "Faktura" : data.activityInfo,
						dueDate: formatDate(data.dueDate ? data.dueDate : data.dateSent),
					};
				}
			)}
			onRowClick={(e: any, rowData: CollectedInvoicesAndNoticesProps) =>
				isMobile &&
				downloadDocument({
					setLoading: () => {},
					setResponseCode: () => {},
					enqueueSnackbar: enqueueSnackbar,
					endpoint: `/api/documents/${rowData.documentJobId}`,
					filename: rowData.invoiceNumber,
				})
			}
			columns={
				isMobile
					? [
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.forfallsDato"
										defaultMessage="Forfallsdato"
										description="Forfallsdato label"
									/>
								),
								field: "dueDate",
							},
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.collectedDataType"
										defaultMessage="Type"
										description="CollectedData type"
									/>
								),
								field: "type",
							},
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.invoices.remainingBalance"
										defaultMessage="Ubetalt"
										description="Remaining balance"
									/>
								),
								field: "remainingBalance",
							},
							{
								render: (data: any, row: any) => {
									return (
										<DownloadDocumentButton
											filename={data.invoiceNumber}
											endpoint={`/api/documents/${data.documentJobId}`}
										/>
									);
								},
								headerStyle: { textAlign: "center" },
								field: undefined,
							},
					  ].map((e: any) => {
							return { cellStyle: { textAlign: "center" }, ...e };
					  })
					: [
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.forfallsDato"
										defaultMessage="Forfallsdato"
										description="Forfallsdato label"
									/>
								),
								field: "dueDate",
							},
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.collectedDataType"
										defaultMessage="Type"
										description="CollectedData type"
									/>
								),
								field: "type",
							},
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.invoices.installmentAmountWithFees"
										defaultMessage="Beløp"
										description="Sum to pay label"
									/>
								),
								field: "installmentAmountWithFees",
							},
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.invoices.invoiceStatus"
										defaultMessage="Status"
										description="Invoice status"
									/>
								),
								field: "status",
							},
							{
								title: (
									<FormattedMessage
										id="minside.loans.tables.invoices.remainingBalance"
										defaultMessage="Ubetalt"
										description="Remaining balance"
									/>
								),
								field: "remainingBalance",
							},
							{
								render: (data: any, row: any) => {
									return (
										<DownloadDocumentButton
											filename={data.invoiceNumber}
											endpoint={`/api/documents/${data.documentJobId}`}
										/>
									);
								},
								headerStyle: { textAlign: "center" },
								field: undefined,
							},
					  ].map((e: any) => {
							return { cellStyle: { textAlign: "center" }, ...e };
					  })
			}
			options={{
				headerStyle: { textAlign: "center" },
				sorting: false,
				rowStyle: (rowdata: CollectedInvoicesAndNoticesProps) => {
					return rowdata.status === InvoiceStatusEnum.Retracted
						? { color: "red" }
						: { color: "black" };
				},
			}}
			{...rest}
		/>
	);
};
